import { render, staticRenderFns } from "./institucional.vue?vue&type=template&id=3523d186&scoped=true&"
import script from "./institucional.vue?vue&type=script&lang=js&"
export * from "./institucional.vue?vue&type=script&lang=js&"
import style0 from "./institucional.vue?vue&type=style&index=0&id=3523d186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523d186",
  null
  
)

export default component.exports